import React from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string;
}
export function Input({
  label,
  error,
  className = '',
  ...props
}: InputProps) {
  return <div className="w-full space-y-2" data-id="element-300">
      <label className="block font-fredoka font-medium text-game-dark dark:text-white ml-1" data-id="element-301">
        {label}
      </label>
      <input className={`
          w-full px-4 py-3 rounded-2xl
          bg-white dark:bg-[#252936]
          border-2 
          ${error ? 'border-game-coral' : 'border-gray-100 dark:border-gray-700'}
          focus:border-game-purple focus:outline-none
          font-quicksand text-game-dark dark:text-white
          placeholder-gray-400
          transition-colors duration-200
          ${className}
        `} {...props} data-id="element-302" />
      {error && <p className="text-game-coral text-sm font-quicksand font-bold ml-1" data-id="element-303">
          {error}
        </p>}
    </div>;
}